export default __webpack_public_path__ + "static/media/wave-image.0411f231.svg";